import React, { useCallback, useEffect } from 'react';
import { has } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router';
import Details from 'components/Details';
import { fetchDetails, fetchSeasons, toggleVodObjectFavoriteStatus } from 'actions/details';
import { navigateToPlayerPage } from 'actions/player';
import { getIsLifecellFlag, getIsLoggedInSelector } from 'reducers/profile/selectors';
import { selectDetailsByContentId, selectLastFocus } from 'reducers/details/selectors';
import { selectIsParentalControlEnabled, selectParentalControlAge } from 'reducers/parental-lock/selectors';
import { CONTENT_TYPES } from 'constants/content-types';
import withKeepingLastFocus from 'components/HOCs/withKeepingLastFocus';
import withModals from 'components/HOCs/withModals';
import { navigateToAuthPage, resetUserData } from 'actions/app';

const CONTENT_TYPE_TO_URL = {
  [CONTENT_TYPES.VOD_ASSET]: 'asset',
  [CONTENT_TYPES.TV_SERIES]: 'tvSeries',
};

export const DetailsContainer = (props) => {
  const { lastFocus, details, match, fetchDetails, fetchSeasons } = props;
  const { contentType, contentId } = match.params;
  const hasDetailsData = has(details, ['data']);

  const loadData = useCallback(async () => {
    await fetchDetails(contentId, CONTENT_TYPE_TO_URL[contentType], false);
    if (contentType === CONTENT_TYPES.TV_SERIES) fetchSeasons(contentId, false);
  }, [contentType, contentId, fetchDetails, fetchSeasons]);

  const selectLastFocused = useCallback(() => {
    if (lastFocus && lastFocus.hasSaved()) lastFocus.apply(lastFocus.reset);
  }, [lastFocus]);

  useEffect(() => {
    if (!hasDetailsData) loadData();

    if (props.history.action === 'POP') {
      selectLastFocused();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentId]);

  return hasDetailsData ? <Details {...props} reloadData={loadData} /> : null;
};

export const mapDispatchToProps = {
  fetchDetails,
  fetchSeasons,
  toggleVodObjectFavoriteStatus,
  navigateToPlayerPage,
  navigateToAuthPage,
  resetUserData,
};

const mapStateToProps = createStructuredSelector({
  details: selectDetailsByContentId,
  isLoggedIn: getIsLoggedInSelector,
  isParentalEnabled: selectIsParentalControlEnabled,
  age: selectParentalControlAge,
  lastFocus: selectLastFocus,
  isLifecellUser: getIsLifecellFlag,
});

export default compose(
  withRouter,
  withKeepingLastFocus,
  withModals,
  connect(mapStateToProps, mapDispatchToProps),
)(DetailsContainer);
